import React from 'react';
import { Alert, Snackbar } from '@mui/material';

interface ErrorObject {
  message?: string;
  error?: {
    message?: string;
    details?: string;
  };
}

type ErrorType = string | ErrorObject | null;

interface ErrorAlertProps {
  error: ErrorType;
  onClose: () => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, onClose }) => {
  if (!error) return null;

  let message: string;
  let details: string | undefined;

  if (typeof error === 'string') {
    message = error;
  } else if (typeof error === 'object') {
    if (error.error) {
      message = error.error.message || 'An error occurred';
      details = error.error.details;
    } else {
      message = error.message || 'An error occurred';
    }
  } else {
    message = 'An error occurred';
  }

  return (
    <Snackbar
      open={!!error}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={onClose} 
        severity="error" 
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
        {details && (
          <div style={{ fontSize: '0.9em', marginTop: '8px' }}>
            {details}
          </div>
        )}
      </Alert>
    </Snackbar>
  );
};

export default ErrorAlert;
